interface VacationWishBannerProps {
  message: string;
  onDismiss: () => void;
}

export function VacationWishBanner({ message, onDismiss }: VacationWishBannerProps) {
  return (
    <div className="eh-vacation-wish-banner relative z-30" data-eh-layout-banner="">
      <div className="eh-vacation-wish-banner__sheen pointer-events-none" aria-hidden="true" />
      <div className="relative mx-auto flex max-w-7xl items-start gap-3 px-4 py-3 sm:items-center sm:px-6">
        <span className="eh-vacation-wish-banner__icon shrink-0" aria-hidden="true">
          <SunHorizonIcon />
        </span>
        <p className="min-w-0 flex-1 text-sm font-medium leading-relaxed text-label sm:text-[0.9375rem]">
          {message}
        </p>
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 rounded-full p-1.5 text-label-secondary transition hover:bg-fill hover:text-label"
          aria-label="Urlaubswunsch schließen"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  );
}

function SunHorizonIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true">
      <path
        d="M4 17h16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 5a5 5 0 0 1 0 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 9.5h10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.45"
      />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="6" y1="6" x2="18" y2="18" />
      <line x1="18" y1="6" x2="6" y2="18" />
    </svg>
  );
}
